// extracted by mini-css-extract-plugin
export default {"name":"wCezp4r1AJNE8rlZ7PBs","link":"C_Dl1j11hRF7CZbG9ZRw","trunc":"GbAHRzP4gwKzQ099z6ZA","icon":"lHU3GVw1hto7efgw1LCL"};